import React, { useContext, useState, useEffect } from "react";
import AppContext from "../../../App/AppContext";
import { TextBox, DialogContents, DialogTitles, Dialogs, SecondaryButton, DialogsActions} from "../../../Core/FormInput";
import CloseIcon from "@material-ui/icons/Close";
import { IconButton } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import "../User Management/UserManagement.css";
import Grid from "@material-ui/core/Grid";
import FormLabel from "@material-ui/core/FormLabel";
import { addBatteryManufacturers, updateBatteryManufacturers } from "../../../Core/Service/BatteryManufacturers-service";

const AddBatteryManufacturersModal = (props) => {
    const { hideModal, showToast } = useContext(AppContext);
    const [state, setState] = useState({
        id: "",
        name:"",
        errors: {},
        fields: {},
    });

    const BatteryManufacturersDetails = props.BatteryManufacturersDetails;

    useEffect(async () => {
        const BatteryManufacturersData = BatteryManufacturersDetails;
        if (BatteryManufacturersDetails) {
            setState((st) => ({
                ...st,
                id: BatteryManufacturersData.id,
                name: BatteryManufacturersData.batteryManufacturerName,
            }));
        }
    }, []);

    const handleClose = () => {
        props.onFormSubmit(false);
        hideModal();
    };

    const fieldChange = (e) => {
        const { name, value } = e.target;
        let fields = state.fields;
        fields[name] = value;
        setState((st) => {
            const nst = { ...st, [name]: value, fields: fields };
            return nst;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (handleValidation()) {
            if(BatteryManufacturersDetails) {
                let res = await updateBatteryManufacturers(
                    state.id,
                    state.name,          
                );
                if (!res.success) {
                    console.error(res);
                } else {
                    hideModal();
                    props.onFormSubmit(true);
                }
            } else {
                let res = await addBatteryManufacturers(
                    null,
                    state.name,            
                );
                if (!res.success) {
                    console.error(res);
                } else {
                    hideModal();
                    props.onFormSubmit(true);
                }
                showToast(res.message);
            }
        }
    };

    const handleValidation = () => {
        let fields = state.fields;
        let errors = {};
        let formIsValid = true;

        if (!state.name) {
            formIsValid = false;
            errors["name"] = "name cannot be empty";
        }

        setState((st) => ({
            ...st,
            errors: errors,
        }));
        return formIsValid;
    };

    return (
        <Dialogs open={true} onClose={handleClose} maxWidth="md">
            <Box display="flex" alignItems="center">
                <Box flexGrow={1}>
                    {BatteryManufacturersDetails ? (
                        <DialogTitles>Update Battery Manufacturers</DialogTitles>
                    ) : (
                        <DialogTitles>Add Battery Manufacturers</DialogTitles>
                    )}
                </Box>
                <Box>
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </Box>
            <DialogContents className="hiddenScroll" style={{ overflow: "auto", height: "8vh",width:'56vh' }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <FormLabel component="legend" className="mandatoryfields">Battery Manufacturer</FormLabel>
                        <TextBox
                            name="name"
                            onChange={fieldChange}
                            value={state.name}
                            autoFocus={BatteryManufacturersDetails ? false : true}
                        />
                         <span className="mandatoryfields">
                            {state.errors["name"]}
                        </span>
                    </Grid>
                </Grid>
            </DialogContents>
            <DialogsActions className="dialogActions">
                <SecondaryButton className="Submitbtn" onClick={handleSubmit}>
                    Submit
                </SecondaryButton>
            </DialogsActions>
        </Dialogs>
    );
};

export default AddBatteryManufacturersModal;